import { Component } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { AFRegistrationDomain, KeyVal } from '../model/af.model';
import { AuthService } from '../service/auth.service';
import { EventService } from '../service/event.service';
import { ShowErrorEvent } from '../service/events';

@Component({
  selector: 'app-security-questions',
  templateUrl: './security-questions.component.html',
  styleUrls: ['./security-questions.component.scss']
})
export class SecurityQuestionsComponent {

  user: AFRegistrationDomain;
  formModel: AFRegistrationDomain;
  showError: boolean = false;
  username: string;
  questionOne: KeyVal;
  questionTwo: KeyVal;
  questionThree: KeyVal;
  questionFour: KeyVal;
  questionFive: KeyVal;

  securityGroup = this.fb.group({
    answer1: ['', Validators.required],
    answer2: ['', Validators.required],
    answer3: ['', Validators.required],
    answer4: ['', Validators.required],
    answer5: ['', Validators.required]
  });

  constructor(private router: Router, private fb: UntypedFormBuilder, private userService: AuthService, private eventBus: EventService) {
    let securityQuestionDomain = new AFRegistrationDomain();
    securityQuestionDomain.verifyId = this.userService.getVerifyId();
    const loginType = Number(localStorage.getItem('loginType'));
    securityQuestionDomain.vendorSign = (loginType == 4);
    this.userService.forgotPassword(securityQuestionDomain).subscribe({
      next: (data: AFRegistrationDomain) => {
        this.user = data;
        this.username = this.user.username;
        this.questionOne = this.user.questionLookup[this.user.question1];
        this.questionTwo = this.user.questionLookup[this.user.question2];
        this.questionThree = this.user.questionLookup[this.user.question3];
        this.questionFour = this.user.questionLookup[this.user.question4];
        this.questionFive = this.user.questionLookup[this.user.question5];
      },
      error: (error: Error) => {
        console.log(error);
      }
    });
  }

  get answer1() { return this.securityGroup.get('answer1') };
  get answer2() { return this.securityGroup.get('answer2') };
  get answer3() { return this.securityGroup.get('answer3') };
  get answer4() { return this.securityGroup.get('answer4') };
  get answer5() { return this.securityGroup.get('answer5') };

  clearError() {
    this.showError = false;
  }

  onSubmit() {
    const loginType = Number(localStorage.getItem('loginType'));

    let securityQuestionDomain = new AFRegistrationDomain();
    securityQuestionDomain.verifyId = this.userService.getVerifyId();

    if (securityQuestionDomain.verifyId) {
      securityQuestionDomain.username = this.user.username;
      securityQuestionDomain.question1 = this.user.question1;
      securityQuestionDomain.question2 = this.user.question2;
      securityQuestionDomain.question3 = this.user.question3;
      securityQuestionDomain.question4 = this.user.question4;
      securityQuestionDomain.question5 = this.user.question5;
      securityQuestionDomain.answer1 = this.answer1.value;
      securityQuestionDomain.answer2 = this.answer2.value;
      securityQuestionDomain.answer3 = this.answer3.value;
      securityQuestionDomain.answer4 = this.answer4.value;
      securityQuestionDomain.answer5 = this.answer5.value;
      securityQuestionDomain.vendorSign = (loginType == 4);
      let observable: Observable<AFRegistrationDomain>;
      if (loginType == 4) {
        observable = this.userService.validateVendorSecurityQuestions(securityQuestionDomain);
      } else {
        observable = this.userService.validateSecurityQuestions(securityQuestionDomain);
      }

      observable.subscribe({
        next: (data: AFRegistrationDomain) => {
          if (data) {
            this.formModel = data;
            if (!data.errorMessage) {
              sessionStorage.setItem('maxCredential', "10");
              this.router.navigate(['resetPassword']);
            } else if (data.errorMessage) {

              this.eventBus.emit(new ShowErrorEvent({ httpStatus: 1, text: data.errorMessage }));
              this.showError = (data.errorMessage ? true : false);
            }
          }
        },
        error: (error: any) => console.log(error)
      });
    }
  }
}
